import { opt } from 'store/opt'

export function openLink(url: string) {
  if (!opt.inline) {
    window.open(url)
    return
  }

  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
